import "../styles/signUp-in.css";
import { useNavigate } from "react-router-dom";

import { useRef, useEffect } from "react";

const SplashScreen = () => {
  const navigate = useNavigate();
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;

    const playPromise = v.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        // Autoplay blocked — you may show a fallback UI if needed
        console.warn("Autoplay blocked");
      });
    }
  }, []);

  const scaleLogo = () => {
    const logoElement = document.querySelector(".splash-video");

    if (logoElement) {
      logoElement.style.transform = "scale(3)";
      logoElement.style.opacity = "0";
      setTimeout(() => {
        navigate("/sign-in");
      }, 1000);
      // listen to aniation end event to navigate to the main app
      logoElement.addEventListener("animationend", () => {});
    }
  };

  return (
    <>
      <div className='SplashScreen'>
        <div>
          <video
            ref={videoRef}
            autoPlay
            muted
            playsInline
            preload='auto'
            onEnded={() => {
              // handle transition to main app
              scaleLogo();
            }}
            className='splash-video'
          >
            <source src={require("../assetsStatic/videoAnimations/StoreLenseLogoAnimated.mp4")} type='video/mp4' />
          </video>
        </div>
        <span className='splashText'>
          Powered by Pragma Solutions Ltd <span className='copyright'>&#169; 2025</span>
        </span>
      </div>
    </>
  );
};

export default SplashScreen;
